export default __webpack_public_path__ + "static/media/sceneOne.b9eb96d1.svg";